import {
  tripLoginModalSignUpDismiss,
  tripLoginModalSignUpView,
} from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import { findCheapestTourV2Variation } from 'lib/tours/tourUtils'
import { isTourV2Offer, isTourV2OfferSummary } from 'lib/offer/offerTypes'
import WishlistOfferBookmarkButton from 'wishlists/components/WishlistOfferBookmarkButton'
import { useTourWishlistDisplayFields } from 'wishlists/hooks/useWishlistDisplayFields'

interface Props {
  offer:
    | App.TourOffer
    | App.TourOfferSummary
    | App.Tours.TourV2Offer
    | App.Tours.TourV2OfferSummary
  selectedVariation?: App.Tours.TourV2OfferVariation
  label?: string
  withLabel?: React.ComponentProps<typeof WishlistOfferBookmarkButton>['withLabel']
  iconKind?: React.ComponentProps<typeof WishlistOfferBookmarkButton>['iconKind']
  iconVariant?: React.ComponentProps<typeof WishlistOfferBookmarkButton>['iconVariant']
}

const trackTripLoginModalSignUpView = () => {
  fireInteractionEvent(tripLoginModalSignUpView('save'))
}
const trackTripLoginModalSignUpDismiss = () => {
  fireInteractionEvent(tripLoginModalSignUpDismiss('save'))
}

function TourBookmarkButton({
  offer,
  selectedVariation,
  label,
  withLabel,
  iconKind,
  iconVariant,
}: Props) {
  const resolvedTourOptionId =
    selectedVariation?.fkTourOptionId ??
    ((isTourV2Offer(offer) || isTourV2OfferSummary(offer))
      ? findCheapestTourV2Variation(offer)?.fkTourOptionId
      : undefined)

  const wishlistDisplayFields = useTourWishlistDisplayFields(offer, selectedVariation)

  return (
    <WishlistOfferBookmarkButton
      item={{
        type: offer.parentType,
        code: offer.id,
        subCode: resolvedTourOptionId,
      }}
      {...wishlistDisplayFields}
      withLabel={withLabel}
      label={label}
      iconKind={iconKind}
      iconVariant={iconVariant}
      onShowLogin={trackTripLoginModalSignUpView}
      onDismissLogin={trackTripLoginModalSignUpDismiss}
    />
  )
}
export default TourBookmarkButton
